module.exports = __webpack_public_path__ + "img/horses-mouth-small.f5a1db24.png";